module.exports = __webpack_public_path__ + "img/mind_icon_number_4.796c7954.png";